// import React, {useState} from 'react'
import React from 'react'
import ChartPie from './ChartPie';
import {formataMoeda} from '../../Helpers/money';
// import {mesesExtenso} from '../../Helpers/date';
// import {mesesExtenso3,hoje} from '../../Helpers/date';
// import Seletor from '../../App/Seletor';
import {
  Typography,
  Card,
  IconButton,
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';

export default function Grafico1(props) {
  const { sel, setSel } = props;
  if (!sel) return null;
  const { Nome, Total, Children } = sel;
  if ( !Nome || Children.length === 0 ) return null;
  return (
    <Card>
      <div style={{
        display: "flex",
        alignItems: "center",
        padding: "0px 10px",
        justifyContent: "space-between",
      }}>
        <Typography variant="title" color="inherit" >
          {Nome}
        </Typography>
        <IconButton onClick={()=>setSel(null)}>
          <Close />
        </IconButton>
      </div>
      <ChartPie 
        data={Children}
        total={Total}
        modif={formataMoeda}
        dataKey={"valor"}
        legendKey={"nome"}
      />
    </Card>
  )
}

